/* eslint-disable class-methods-use-this */

import { pick } from '@utils/pick';
import DataConverter from './DataConverter.model';
import ProductSpecModel, {
  IProductSpec,
  IProductSpecSQLApiModel,
} from './ProductSpec.model';

export interface IProductSpecGroupApiModel {
  id: string;
  specGroupName: string | null;
  productId: string;
  specNames: IProductSpecSQLApiModel[];
}

export interface IProductSpecGroup {
  id: string;
  specGroupName: string | null;
  productId: string;
  specNames: IProductSpec[];
}

const SHARED = ['id', 'productId', 'specGroupName'] as const;
class ProductSpecGroupConverter extends DataConverter<
  IProductSpecGroupApiModel,
  IProductSpecGroup
> {
  fromApiModel(model: IProductSpecGroupApiModel): IProductSpecGroup {
    const { specNames } = model;
    const picked = pick(model, SHARED);

    const specNamesConverted = ProductSpecModel.fromArrayApiModel(specNames);

    return {
      specNames: specNamesConverted,
      ...picked,
    };
  }
}

export default new ProductSpecGroupConverter();
